import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

/**
 * روابط التواصل الاجتماعي.
 *
 * كانت كلها تعرض أيقونة كرة أرضية واحدة بلا اسم — فيرى الزائر ستّة
 * أزرار متطابقة ولا يعرف أيّها يوتيوب. والشعار هو ما يُتعرَّف به على
 * المنصّة قبل أي كلمة، وإسقاطه يجعل الأزرار الستّة زرّاً واحداً مكرّراً.
 *
 * و`Globe` تبقى احتياطاً لمنصّة لا أيقونة لها في المكتبة — أفضل من ألّا
 * يظهر الرابط أصلاً.
 */
/*
  الشعارات مرسومة هنا لا مأخوذة من lucide.
  ---------------------------------------
  أيقونات lucide خطّية موحّدة الأسلوب — جميلة في واجهة، ورديئة كشعار
  علامة: `Youtube` منها مستطيل مجوّف بمثلّث صغير، فيبدو مربّعاً فارغاً
  ولا يتعرّف عليه أحد. وشعار المنصّة يُعرف بامتلائه وشكله الخاصّ، لا
  بخطّ حوله.

  فهذه مسارات الشعارات الرسمية مبسّطة، ممتلئة بـ`currentColor` — تتلوّن
  بلون الرابط وتبقى واضحة عند ١٦ بكسل.
*/
const PATHS: Record<string, string> = {
  youtube:
    'M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z',
  facebook:
    'M24 12a12 12 0 1 0-13.9 11.9v-8.4H7.1V12h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-2 .9-2 1.9V12h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12z',
  instagram:
    'M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.4-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4 1.3-.1 1.7-.1 4.9-.1zM12 7.8a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4zm0 6.9a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zm5.3-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z',
  linkedin:
    'M20.4 20.4h-3.6v-5.6c0-1.3 0-3-1.9-3s-2.1 1.4-2.1 2.9v5.7H9.3V9h3.4v1.6h.1a3.8 3.8 0 0 1 3.4-1.9c3.6 0 4.3 2.4 4.3 5.5v6.2zM5.3 7.4a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2zM7.1 20.4H3.5V9h3.6v11.4zM22.2 0H1.8C.8 0 0 .8 0 1.7v20.6c0 .9.8 1.7 1.8 1.7h20.4c1 0 1.8-.8 1.8-1.7V1.7C24 .8 23.2 0 22.2 0z',
  x:
    'M18.2 2.3h3.3l-7.2 8.2 8.5 11.2h-6.7l-5.2-6.9-6 6.9H1.6l7.7-8.8L1.2 2.3h6.8l4.7 6.3 5.5-6.3zm-1.2 17.6h1.8L7.1 4.1H5.2l11.8 15.8z',
  tiktok:
    'M16.6 0h-3.3v13.4a2.8 2.8 0 1 1-2.8-2.8c.3 0 .6 0 .8.1V7.4a6.2 6.2 0 1 0 5.3 6.1V6.9a7.6 7.6 0 0 0 4.4 1.4V5a4.4 4.4 0 0 1-4.4-4.4V0z',
};

/* الاسم يبقى في `title` و`aria-label` لا في الزرّ: من يمرّ بالمؤشّر
   يراه، ومن يستعمل قارئ شاشة يسمعه، ولا يتمدّد الزرّ. */
const LABELS: Record<string, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  x: 'X',
  linkedin: 'LinkedIn',
  youtube: 'YouTube',
  tiktok: 'TikTok',
};

export function SocialLinks({ links }: { links: [string, string][] }) {
  const { t } = useTranslation();
  if (links.length === 0) return null;

  return (
    <span className="social-links">
      {links.map(([key, url]) => {
        const path = PATHS[key];
        const label = LABELS[key] ?? key;
        return (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noreferrer noopener"
            className={`social-${key}`}
            aria-label={t('footer.followOn', { name: label })}
            title={label}
          >
            {path ? (
              <svg viewBox="0 0 24 24" width={16} height={16} aria-hidden focusable="false">
                {/*
                  `evenodd` إلزامية.
                  ----------------
                  شعارات مثل يوتيوب وإنستغرام مسارٌ خارجي وداخله ثقب
                  (المثلّث، العدسة). وقاعدة `nonzero` الافتراضية تملأ
                  الاثنين، فيصير الشعار مربّعاً مصمتاً بلا ملامح — وهو
                  ما جعل يوتيوب يبدو صندوقاً فارغاً.

                  و`evenodd` تثقب الداخل فيظهر الشكل. وهي صحيحة لكل
                  الشعارات القادمة أيضاً — فيسبوك وإنستغرام ولينكدإن.
                */}
                <path d={path} fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
              </svg>
            ) : (
              <Globe size={16} aria-hidden />
            )}
          </a>
        );
      })}
    </span>
  );
}
